/**
 * Builds fed/wed/bed-style tap stages when JSON omits `interactiveTapSteps`.
 * Three steps: equal letters → bridged letters → merge row (last tapOrder chunk only  ed).
 */
export function deriveClusterInteractiveTapSteps(blend) {
  const order = blend?.build?.order;
  const mergeChunks = blend?.merge?.chunks;
  const tapOrder = blend?.merge?.tapOrder ?? mergeChunks;
  if (!Array.isArray(order) || order.length !== 3 || !mergeChunks?.length || !tapOrder?.length) {
    return null;
  }
  const [a, b] = order;
  const lastChunkTap = tapOrder[tapOrder.length - 1];
  return [
    { chunks: [...order], layout: "clusterEqual", expect: "letter", target: a },
    { chunks: [...order], layout: "clusterBridge", expect: "letter", target: b },
    {
      chunks: [...mergeChunks],
      layout: "mergeWide",
      expect: "chunk",
      target: lastChunkTap,
    },
  ];
}
